import React, { useState } from "react";
import { useParams, useNavigate } from "react-router";
// react redux
import { useSelector } from "react-redux";
// react-hook-form
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// mui
import { Stack, FormControlLabel, Switch } from "@mui/material";
// componennts
import { PageTitle, SubmitButton, InputField } from "../../components";
// schema
import { addCitySchema } from "../../schemes/city/addCitySchema";
import { errorAlert, successAlert } from "../../utils/alerts/alerts";
import EnhancedAxios from "../../axios/EnhancedAxios";
// form values type
type FormValues = {
    name: string;
    is_disabled: boolean;
};

const AddCity = () => {
    const navigate = useNavigate();
    const userToken = useSelector((state: any) => state.user.userToken);
    const [submitting, setSubmitting] = useState(false);
    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        defaultValues: {
            name: "",
            is_disabled: false,
        },
        resolver: yupResolver(addCitySchema),
        mode: "all",
    });
    const {
        register,
        setValue,
        reset,
        control,
        watch,
        formState: { errors },
        handleSubmit,
    } = form;
    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setSubmitting(true);
        EnhancedAxios(null, userToken)
            .post(`/admin/cities`, data)
            .then((res: any) => {
                successAlert(`تم اضافة مدينة '${data.name}'`);
                reset();
                setSubmitting(false);
                navigate(-1);
            })
            .catch((error: any) => {
                errorAlert(error);
                setSubmitting(false);
            });
    };
    return (
        <Stack gap="20px">
            <PageTitle title="اضافة مدينة" />
            <Stack alignItems="center">
                <Stack
                    width="100%"
                    maxWidth="800px"
                    gap="10px"
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <InputField
                        type="text"
                        registration={{ ...register("name") }}
                        label="الاسم"
                        errorMessage={errors?.name?.message}
                    />
                    <Controller
                        name="is_disabled"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={!watch("is_disabled")}
                                        onChange={(e) =>
                                            setValue(
                                                "is_disabled",
                                                !e.target.checked
                                            )
                                        }
                                    />
                                }
                                label="مفعل"
                            />
                        )}
                    />
                    <SubmitButton label="انشاء" disabled={submitting} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default AddCity;
